import React from 'react'
import type { OnSubmit } from './types'

export function useSubmitReinitialize<Values, Result extends Values>(submitHandler: OnSubmit<Values, Result>): OnSubmit<Values, Result> {
  return React.useCallback(
    async (values, formikHelpers) => {
      const result = await submitHandler(values, formikHelpers)

      formikHelpers.resetForm({ values: result })

      return result
    },
    [submitHandler]
  )
}
